import React from 'react';
import { errorsWithEntities } from '@/utils/errors';
import ErrorMessages from './ErrorMessages';

const EntitiesErrorMessages = ({
  category,
  code,
  contexts,
  entities = ['server'],
  entity,
  errors,
  onDismiss,
}) => (
  <ErrorMessages
    category={category}
    code={code}
    contexts={contexts}
    entity={entity}
    errors={errorsWithEntities(errors, entities)}
    onDismiss={onDismiss}
  />
);

export default EntitiesErrorMessages;
